import { WorkoutMode } from '@kinomap-dev/ng-ui-lib/core';
import { UploadWorkoutMessage } from '../services/upload-service';
import { SectionModelType } from '../types/section.type';
import { Duration } from '../types/duration.type';
import { DIFFICULTY_LEVEL_COLORS } from '../configs/sections-editor/workout-mode-colors.config';
import { getDifficultyLevel } from './section-difficulty.utils';

type WorkoutSegment = UploadWorkoutMessage['segments'][number];

export const convertCreatedWorkoutSegmentsToApiFormat = (
  sections: SectionModelType[],
  datasOf: (section: SectionModelType) => { type: WorkoutMode; value: number }[],
): UploadWorkoutMessage['segments'] => {
  const convertedSegments: WorkoutSegment[] = [];

  sections.forEach((section: SectionModelType, index: number) => {
    const [primary, secondary] = datasOf(section);
    const segment: WorkoutSegment = {
      name: index.toString(),
      ...durationToHMS(section.duration),
      color: difficultyHexColor(primary.value, primary.type),
      optimalCadence: section.cadence,
      order: index + 1,
      value: primary.value,
      value_secondary: secondary?.value,
    };

    convertedSegments.push(segment);
    if (secondary) {
      convertedSegments.push({ ...segment, value: secondary.value });
    }
  });

  return convertedSegments;
};

function durationToHMS(duration: Duration): { h: number; m: number; s: number } {
  return {
    h: Math.floor(duration.minutes / 60),
    m: duration.minutes % 60,
    s: duration.seconds,
  };
}

function difficultyHexColor(value: number, mode: WorkoutMode): string {
  const color: string = DIFFICULTY_LEVEL_COLORS[getDifficultyLevel(value, mode)];
  return color.match(/#[0-9a-fA-F]{3,8}/)?.[0] ?? color;
}

